<template>
    <div class="columns is-mobile is-centered has-background-primary p-2">
        <h1 class="title is-4 has-text-white"><i class="fas fa-arrow-right-from-bracket"></i> &nbsp; LEAD DI VENDITA</h1>
    </div>

    <div class="box" @submit.prevent="" v-if="formAttivo">

        <!--********** BOTTONI DI GESTIONE LEAD **********-->
        <div class="columns">
            <div class="column">
                <div class="field buttons">
                    <button class="button is-light"  @click="bAnnulla" :disabled="interfacciaBloccata || !leadDaAggiornare">Annulla</button>
                    <button class="button is-primary" @click="bSalva" :disabled="interfacciaBloccata || !leadDaAggiornare">Salva</button>
                </div>                
            </div>
            <div class="column" v-if="schermoLargo">
                <p>
                    <a @click="bCambiaCliente()" title="Cambia cliente"><i class="fas fa-user"></i> &lt; &ndash; &gt; <i class="fas fa-user"></i></a>
                </p>
            </div>
            <div class="column" v-if="schermoLargo">
                <p>
                    <a @click="gestisciSelezioneElemento({tipo: 'cliente', idCliente: props.idCliente})" title="Vai al cliente">
                        <i class="fas fa-user"></i> &nbsp; {{ generaStringaCliente(props.idCliente) }}
                    </a>
                </p>
            </div>
            <div class="column" v-if="props.idLead!=-1 && schermoLargo">
                <p>
                    <a><i class="fas fa-arrow-right-from-bracket"></i> &nbsp; {{ dbClienti[props.idCliente].leads[props.idLead].oggetto }}</a>
                </p>
            </div>
            <div class="column" v-if="schermoLargo">
                <div class="field buttons is-right">
                    <button class="button is-danger" @click="bElimina" v-if="idLeadSelezionato!=-1 && permettiElimina" :disabled="interfacciaBloccata">Elimina</button>
                </div>
            </div>
        </div>

        <div class="blocco-scroll">

            <!--********** BOTTONI DI GESTIONE LEAD MOBILE**********-->
            <div class="columns" v-if="!schermoLargo">
                <div class="column">
                    <p>
                        <a @click="bCambiaCliente()" title="Cambia cliente"><i class="fas fa-user"></i> &lt; &ndash; &gt; <i class="fas fa-user"></i></a>
                    </p>
                </div>
                <div class="column">
                    <p>
                        <a @click="gestisciSelezioneElemento({tipo: 'cliente',  idCliente: props.idCliente})" title="Vai al cliente"><i class="fas fa-user"></i> &nbsp; {{ generaStringaCliente(props.idCliente) }}</a>
                    </p>
                </div>
                <div class="column" v-if="props.idLead!=-1">
                    <p>
                        <a><i class="fas fa-arrow-right-from-bracket"></i> &nbsp; {{ dbClienti[props.idCliente].leads[props.idLead].oggetto }}</a>
                    </p>
                </div>
            </div>

            <!--********** LINGUETTE DI SCELTA TABS FORM LEAD **********-->
            <div class="tabs">
                <ul>
                    <li :class="{'is-active': statoInterfaccia.formLeadTab == 1}">
                        <a @click="bSelezionaTAb(1)">
                            <span>Lead</span>
                        </a>
                    </li>
                    <li :class="{'is-active': statoInterfaccia.formLeadTab == 2}">
                        <a @click="bSelezionaTAb(2)">
                            <span>Preventivi</span>
                        </a>
                    </li>
                    <li :class="{'is-active': statoInterfaccia.formLeadTab == 3}">
                        <a @click="bSelezionaTAb(3)">
                            <span>Contatti</span>
                        </a>
                    </li>
                </ul>
            </div>

            <!--********** FORM LEAD **********-->
            <div class="columns" v-if="statoInterfaccia.formLeadTab==1">
                <div class="column is-8">
                    <div class="field">
                        <label class="label">Oggetto</label>
                        <div class="control">
                            <input class="input" type="text" v-model="leadSelezionato.oggetto"  @change="leadModifica(leadSelezionato.oggetto, 'oggetto')">
                        </div>
                    </div>
                </div>
                <div class="column is-2">
                    <CampoTendina @valoreCambiato="(valore)=>leadModifica(valore, 'stato')"
                        :valore=leadSelezionato.stato
                        idTendina="lead.stato"
                        etichetta="Stato"/>
                </div>
                <div class="column is-2">
                    <CampoTendina @valoreCambiato="(valore)=>leadModifica(valore, 'fase')"
                        :valore=leadSelezionato.fase
                        idTendina="lead.fase"
                        etichetta="Fase"/>
                </div>
            </div>
            <div class="columns" v-if="statoInterfaccia.formLeadTab==1">
                <div class="column is-2">
                    <CampoData @valoreCambiato="leadModifica"
                        :valore=leadSelezionato.primoContattoData
                        identificativo="primoContattoData"
                        etichetta="Data primo contatto"/>
                </div>
                <div class="column is-2">
                    <CampoTendina @valoreCambiato="(valore)=>leadModifica(valore, 'primoContattoFonte')"
                        :valore=leadSelezionato.primoContattoFonte
                        idTendina="lead.primoContattoFonte"
                        etichetta="Fonte primo contatto"/>
                </div>
                <div class="column is-4">
                    <div class="field">
                        <label class="label">Credit primo contatto</label>
                        <div class="control">
                            <input class="input" type="text" v-model="leadSelezionato.primoContattoCredit"  @change="leadModifica(leadSelezionato.primoContattoCredit, 'primoContattoCredit')">
                        </div>
                    </div>
                </div>
                <!-- <div class="column is-2">
                    <CampoData @valoreCambiato="leadModifica"
                        :valore=leadSelezionato.propostaAegData
                        identificativo="propostaAegData"
                        etichetta="Data proposta AEG"/>
                </div>
                <div class="column is-2">
                    <CampoTendina @valoreCambiato="(valore)=>leadModifica(valore, 'propostaAegTipo')"
                        :valore=leadSelezionato.propostaAegTipo
                        idTendina="lead.propostaAegTipo"
                        etichetta="Tipo di proposta"/>
                </div> -->
            </div>
            <div class="columns" v-if="statoInterfaccia.formLeadTab==1">
                <div class="column is-3">
                    <label class="label">Indirizzo</label>
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <input class="input" type="text" v-model="leadSelezionato.indirizzo"  @change="leadModifica(leadSelezionato.indirizzo, 'indirizzo')">
                        </div>
                        <div class="control">
                            <button class="button is-primary" @click="apriLinkLuogo(leadSelezionato.indirizzo)">
                                <p><i class="fas fa-location-dot"></i></p>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="column is-1">
                    <div class="field">
                        <label class="label">&nbsp;</label>
                        <button class="button is-primary is-outlined" @click="bCopiaIndirizzoAnagrafica()">
                            <span class="icon" title="Copia indirizzo dall'anagrafica"><i class="fas fa-file-import"></i></span>
                        </button>
                    </div>
                </div>
                <div class="column is-3">
                    <div class="field">
                        <label class="label">Posizione</label>
                        <div class="field has-addons">
                            <div class="control is-expanded">
                                <input class="input" type="text" v-model="leadSelezionato.luogo"  @change="leadModifica(leadSelezionato.luogo, 'luogo')">
                            </div>
                            <div class="control">
                                <button class="button is-primary" @click="apriLinkLuogo(leadSelezionato.luogo)">
                                    <p><i class="fas fa-location-dot"></i></p>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column is-1">
                    <div class="field">
                        <label class="label">&nbsp;</label>
                        <button class="button is-primary is-outlined" @click="bCopiaPosizione()">
                            <span class="icon" title="Copia indirizzo e posizione"><i class="fas fa-copy"></i></span>
                        </button>
                        &nbsp;
                        <button class="button is-primary is-outlined" @click="bIncollaPosizione()" :disabled="!('posizione' in copiaTrasporto)">
                            <span class="icon" title="Incolla indirizzo e posizione"><i class="fas fa-paste"></i></span>
                        </button>
                    </div>
                </div>
                <!-- <div class="column is-2">
                    <CampoData @valoreCambiato="leadModifica"
                        :valore=leadSelezionato.contrattoAegData
                        identificativo="contrattoAegData"
                        etichetta="Data contratto AEG"/>
                </div>
                <div class="column is-2">
                    <CampoTendina @valoreCambiato="(valore)=>leadModifica(valore, 'contrattoAegTipo')"
                        :valore=leadSelezionato.contrattoAegTipo
                        idTendina="lead.contrattoAegTipo"
                        etichetta="Tipo di contratto"/>
                </div> -->
            </div>
            <div class="columns" v-if="statoInterfaccia.formLeadTab==1">
                <div class="column is-2">
                    <CampoData @valoreCambiato="leadModifica"
                        :valore=leadSelezionato.ultimoContattoData
                        identificativo="ultimoContattoData"
                        etichetta="Data ultimo contatto"/>
                </div>
                <div class="column is-2">
                    <CampoData @valoreCambiato="leadModifica"
                        :valore=leadSelezionato.finalizzazioneData
                        identificativo="finalizzazioneData"
                        etichetta="Data finalizzazione"/>
                </div>
                <div class="column is-6">
                    <CampoNumero @valoreCambiato="leadModifica"
                        :valore=leadSelezionato.finalizzazioneImporto
                        identificativo="finalizzazioneImporto"
                        etichetta="Importo finalizzazione"
                        :decimali=2
                        tipo="Decimale"/>
                </div>
            </div>
            <div class="columns" v-if="statoInterfaccia.formLeadTab==1">
                <!-- <div class="column is-12">
                    <div class="field">
                        <label class="label">Tag</label>
                        <div class="control">
                            <div class="tags mb-2" v-if="leadSelezionato.tags && leadSelezionato.tags.length > 0">
                                <span class="tag is-primary is-light is-medium" v-for="(tag, index) in leadSelezionato.tags" :key="index">
                                    {{ tag }}
                                    <button class="delete is-small" @click="bRimuoviTag(index)"></button>
                                </span>
                            </div>
                            <div class="field has-addons">
                                <div class="control is-expanded">
                                    <input class="input" type="text" v-model="nuovoTag" @keyup.enter="bAggiungiTag" list="lista-tags" placeholder="Inserisci un nuovo tag e premi Invio...">
                                    <datalist id="lista-tags" v-if="impostazioniGenerali.tagsLeads">
                                        <option v-for="tagGlobale in impostazioniGenerali.tagsLeads" :key="tagGlobale" :value="tagGlobale"></option>
                                    </datalist>
                                </div>
                                <div class="control">
                                    <button class="button is-primary is-outlined" @click="bAggiungiTag" title="Aggiungi Tag">
                                        <span class="icon"><i class="fas fa-plus"></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="column is-12">
                    <div class="field">
                        <label class="label">Tag</label>
                        <div class="control">
                            <div class="tags mb-2" v-if="leadSelezionato.tags && leadSelezionato.tags.length > 0">
                                <span class="tag is-primary is-light is-medium" v-for="(tag, index) in leadSelezionato.tags" :key="index">
                                    {{ tag }}
                                    <button class="delete is-small" @click="bRimuoviTag(index)"></button>
                                </span>
                            </div>
                            <div class="field has-addons">
                                <div class="control is-expanded">
                                    <input class="input" type="text" v-model="nuovoTag" @keyup.enter="bAggiungiTag" @change="bAggiungiTag" list="lista-tags" placeholder="Seleziona dalla tendina o digita e premi Invio...">
                                    <datalist id="lista-tags" v-if="tagsGlobaliOrdinati.length > 0">
                                        <option v-for="tagGlobale in tagsGlobaliOrdinati" :key="tagGlobale" :value="tagGlobale"></option>
                                    </datalist>
                                </div>
                                <div class="control">
                                    <button class="button is-primary is-outlined" @click="bAggiungiTag" title="Aggiungi Tag">
                                        <span class="icon"><i class="fas fa-plus"></i></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns" v-if="statoInterfaccia.formLeadTab==1">
                <div class="column">
                    <div class="field">
                        <label class="label">Note</label>
                        <div class="control">
                            <textarea class="textarea" placeholder="Note"  rows="4" v-model="leadSelezionato.note"  @change="leadModifica(leadSelezionato.note, 'note')"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <!--********** PREVENTIVI **********-->
            <FormPreventivo v-if="idPreventivoSelezionato && statoInterfaccia.formLeadTab==2"
                :id-cliente=leggiInfoDB(leadSelezionato).idCliente
                :id-lead=leggiInfoDB(leadSelezionato).id
                :id-preventivo=idPreventivoSelezionato
                vista="ridotta"
                @modificaElementoInCorso="bBloccaInterfaccia"
                @elementoSelezionato="gestisciSelezioneElemento"/>
            <ElencoPreventivi
                :bottoneAggiungiVisibile=true
                :cliente=leggiInfoDB(leadSelezionato).idCliente
                :lead=leggiInfoDB(leadSelezionato).id
                :campoRicercaVisibile=false
                :titoloVisibile=false
                @elementoSelezionato="gestisciSelezioneElemento"
                v-if="statoInterfaccia.formLeadTab==2 && leggiInfoDB(leadSelezionato).id"/>

            <!--********** CONTATTI **********-->
            <ElencoContatti
                :bottoneAggiungiVisibile=true
                :cliente=leggiInfoDB(leadSelezionato).idCliente
                :lead=leggiInfoDB(leadSelezionato).id
                :campoRicercaVisibile=false
                :titoloVisibile=false
                @elementoSelezionato="gestisciSelezioneElemento"
                @copiaContatti="bCopiaContatti"
                @incollaContatti="bIncollaContatti"
                v-if="statoInterfaccia.formLeadTab==3 && leggiInfoDB(leadSelezionato).id"/>

            <div>&nbsp;</div>
        </div>
    </div>

    <!-- MESSAGGIO MODALE -->
    <MessaggioModale @selezionato="bComandoModale"
        :confMessaggioModale=messaggioModale
        v-if="messaggioModale"/>

    <!-- ELENCO CLIENTI MODALE PER CAMBIO CLIENTE -->
    <ElencoClientiModale
        :bottoneAggiungiVisibile=false
        :campoRicercaVisibile=true
        @elementoSelezionato="bCambiaClienteDaModale"
        v-if="mostraElencoClientiModale"/>

</template>

<script setup>

    import CampoData from "./CampoData.vue";
    import CampoNumero from "./CampoNumero.vue";
    import CampoTendina from "./CampoTendina.vue";
    import MessaggioModale from "./MessaggioModale.vue";
    import ElencoClientiModale from "./ElencoClientiModale.vue";
    import ElencoPreventivi from "./ElencoPreventivi.vue";
    import FormPreventivo from "./FormPreventivo.vue";
    import ElencoContatti from "./ElencoContatti.vue";
    import { defineProps, defineEmits, ref, nextTick, watch, computed } from "vue";
    import { dbClienti, salvaLeadInFirestore, salvaLavoroInFirestore, eliminaLeadInFirestore, cambiaClienteALeadInFirestore, leggiInfoDB, leggiInfoDBRaw, aggiungiInfoDB, aggiungiTagLeadInFirestore } from "./../code/gestioneDB";
    import { generaIdLead, generaIdLavoro, generaStringaCliente, apriLinkLuogo, permettiElimina, copiaTrasporto, statoInterfaccia, clonaOggetto, schermoLargo, impostazioniGenerali } from "./../code/utilita";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        idLead: {
            type: Number,
            default: null
        },
        idCliente: {
            type: Number,
            default: -1
        }
    });
    const emit = defineEmits(['elementoSelezionato', 'modificaElementoInCorso']);

    // VARIABILI DEL COMPONENTE
    const nuovoTag = ref('');
    const leadSelezionato = ref({});             
    const leadDaAggiornare = ref(null);            
    const messaggioModale = ref(null);             
    const mostraElencoClientiModale = ref(false);           
    const idLeadSelezionato = ref(props.idLead || -1);
    const idPreventivoSelezionato = ref(null);
    const interfacciaBloccata = ref(false);
    const formAttivo = ref(true);                 

    // Computed property per ordinare i tag alfabeticamente portando "Altro" in fondo
    const tagsGlobaliOrdinati = computed(() => {
        if (!impostazioniGenerali.value || !impostazioniGenerali.value.tagsLeads) return [];
        
        // Creiamo una copia dell'array con lo spread operator [...] per non mutare l'originale
        return [...impostazioniGenerali.value.tagsLeads].sort((a, b) => {
            const tagA = a.toLowerCase();
            const tagB = b.toLowerCase();
            
            // Gestione dell'eccezione per la voce "altro"
            if (tagA === 'altro') return 1;  // Sposta 'a' dopo 'b'
            if (tagB === 'altro') return -1; // Sposta 'b' dopo 'a'
            
            // Ordinamento alfabetico standard per tutti gli altri
            return tagA.localeCompare(tagB);
        });
    });

    // FIX: Watcher di sicurezza per cambi asincroni
    watch(() => props.idLead, (nuovoId) => {
        idLeadSelezionato.value = nuovoId || -1;
        setupFormLead();
    });

    // SETUP DEL COMPONENTE
    setupFormLead();

    // FUNZIONI DEL COMPONENTE
    function setupFormLead() {
        if (!statoInterfaccia.value.formLeadTab || (props.idLead==-1) ) 
            statoInterfaccia.value.formLeadTab = 1;
        
        const id = idLeadSelezionato.value;

        // FIX: Scheletro di Base per i Leads per prevenire crash su v-model nidificati
        const scheletroBase = {
            stato: null,
            fase: null,
            tags: [],
            contatti: {}
        };

        if ( id == -1 ) {
            leadSelezionato.value = { ...scheletroBase };
            aggiungiInfoDB(leadSelezionato.value, {
                id: -1,
                idCliente: props.idCliente,
                stringaCliente: generaStringaCliente(props.idCliente)
            });
        } else {
            // FIX: Estrazione Sicura usando SEMPRE props.idCliente
            const clienteOriginale = dbClienti.value[props.idCliente];
            const leadOriginale = (clienteOriginale && clienteOriginale.leads) ? clienteOriginale.leads[id] : null;

            if (leadOriginale) {
                // Clona e applica lo scheletro
                leadSelezionato.value = { ...scheletroBase, ...clonaOggetto(leadOriginale) };
                
                // --- FIX TAGS ---
                // clonaOggetto trasforma gli Array in Oggetti {0: 'a', 1: 'b'}. 
                // Ripristiniamo esplicitamente l'Array originale per riavere .length e i metodi nativi
                if (leadOriginale.tags && Array.isArray(leadOriginale.tags)) {
                    leadSelezionato.value.tags = [...leadOriginale.tags];
                } else if (!Array.isArray(leadSelezionato.value.tags)) {
                    leadSelezionato.value.tags = [];
                }
                // ----------------
                
                // Ricostruisce il DNA (i metadati) per il clone orfano per sopravvivere alla promozione Freddo->Caldo
                const infoRaw = leggiInfoDBRaw(leadOriginale) || { id: id, idCliente: props.idCliente };
                aggiungiInfoDB(leadSelezionato.value, infoRaw);
            } else {                // Fallback di sicurezza
                leadSelezionato.value = { ...scheletroBase };
                aggiungiInfoDB(leadSelezionato.value, { id: id, idCliente: props.idCliente });
            }
        }
        leadDaAggiornare.value = null;
    }

    function leadModifica(valore, etichetta) {
        if (leadDaAggiornare.value == null) {
            leadDaAggiornare.value = {};
            emit('modificaElementoInCorso', true);
        }
        leadDaAggiornare.value[etichetta] = valore;
        leadSelezionato.value[etichetta] = valore;
    }

    function bAnnulla() {
        if (leadDaAggiornare.value != null) {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:null,
                testoDanger:{testo:'Cancella le modifiche', comando:'cancella'},
                messaggio:"Proseguendo perderai le modifiche fatte"
            };
        }
    }

    function bSalva() {
        if (leadSelezionato.value.stato == 'Archiviato' && leadSelezionato.value.fase != 'Chiuso') {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:{testo:'Salva', comando:'salva'},
                testoDanger:null,
                messaggio:"Stai archiviando il lead ma NON hai concluso la vendita. Sei sicuro di procedere?"
            };
            return;
        } else if (leadSelezionato.value.stato == 'Archiviato' && leadSelezionato.value.fase == 'Chiuso' && ( !leadSelezionato.value.finalizzazioneImporto || !leadSelezionato.value.finalizzazioneData ) ) {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Hai concluso la vendita ma non hai inserito l'importo o la data di finalizzazione."
            };
            return;
        } else if (leadSelezionato.value.stato == 'Archiviato' && leadSelezionato.value.fase == 'Chiuso' && leadSelezionato.value.finalizzazioneImporto && leadSelezionato.value.finalizzazioneData ) {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:{testo:'Salva', comando:'salva'},
                testoDanger:{testo:'Salva e apri un nuovo lavoro', comando:'salvaEApriLavoro'},
                messaggio:"Hai concluso la vendita. Stai salvando le modifiche al lead. Vuoi aprire un nuovo lavoro da questo lead?"
            };
            return;
        } else if (!leadSelezionato.value.tags || leadSelezionato.value.tags.length === 0) {
            messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Prima di salvare inserisci almeno un Tag."
            };
            return;
        } else {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:{testo:'Salva', comando:'salva'},
                testoDanger:null,
                messaggio:"Vuoi salvare le modifiche al Lead?"
            };
        }
    }

    function bElimina() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:null,
            testoDanger:{testo:'Elimina', comando:'elimina'},
            messaggio:"Vuoi eliminare il Lead?"
        };
    }

    async function bComandoModale(comando) {
        const tpIdCliente = leggiInfoDBRaw(leadSelezionato.value).idCliente || props.idCliente; // Sicurezza extra
        let lavoroDaAggiornare = {};
        
        switch (comando) {
            case 'annulla': {
                messaggioModale.value = null;
                break;
            }
            case 'cancella': {
                emit('modificaElementoInCorso', false);
                messaggioModale.value = null;
                setupFormLead();
                resetForm();
                break;
            }
            case 'salva': {
                if (idLeadSelezionato.value == -1) {
                    idLeadSelezionato.value = generaIdLead();
                }
                aggiungiInfoDB(leadDaAggiornare.value, {
                    id: idLeadSelezionato.value,
                    idCliente: tpIdCliente
                });
                await salvaLeadInFirestore(leadDaAggiornare.value);
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'lead',
                    idCliente: tpIdCliente,
                    idLead: idLeadSelezionato.value
                });
                break;
            }
            case 'salvaEApriLavoro': {
                if (idLeadSelezionato.value == -1) {
                    idLeadSelezionato.value = generaIdLead();
                }
                aggiungiInfoDB(leadDaAggiornare.value, {
                    id: idLeadSelezionato.value,
                    idCliente: tpIdCliente
                });
                await salvaLeadInFirestore(leadDaAggiornare.value);
                
                aggiungiInfoDB(lavoroDaAggiornare, {
                    id: generaIdLavoro(),
                    idCliente: tpIdCliente
                });
                if (leadSelezionato.value.contatti) {
                    lavoroDaAggiornare.contatti = {};
                    lavoroDaAggiornare.contatti = leadSelezionato.value.contatti;
                }
                if (leadSelezionato.value.luogo) lavoroDaAggiornare.luogo = leadSelezionato.value.luogo;
                if (leadSelezionato.value.indirizzo) lavoroDaAggiornare.indirizzo = leadSelezionato.value.indirizzo;
                if (leadSelezionato.value.oggetto) lavoroDaAggiornare.oggetto = leadSelezionato.value.oggetto;
                if (leadSelezionato.value.finalizzazioneData) lavoroDaAggiornare.dataOrdine = leadSelezionato.value.finalizzazioneData;
                await salvaLavoroInFirestore(lavoroDaAggiornare);

                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'lead',
                    idCliente: tpIdCliente,
                    idLead: idLeadSelezionato.value
                });
                break;
            }
            case 'elimina': {
                eliminaLeadInFirestore(tpIdCliente, idLeadSelezionato.value);
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'cliente',
                    idCliente: tpIdCliente
                });
                break;
            }
            case 'incollaContatti': {
                leadDaAggiornare.value = {};
                aggiungiInfoDB(leadDaAggiornare.value, {
                    id: props.idLead,
                    idCliente: props.idCliente
                });
                leadDaAggiornare.value.contatti = copiaTrasporto.value.contatti;
                await salvaLeadInFirestore(leadDaAggiornare.value);
                leadDaAggiornare.value = null;
                messaggioModale.value = null;
                break;
            }
            case 'incollaPosizione': {
                if (copiaTrasporto.value.posizione.indirizzo) {
                    leadModifica(copiaTrasporto.value.posizione.indirizzo, 'indirizzo');
                }
                if (copiaTrasporto.value.posizione.luogo) {
                    leadModifica(copiaTrasporto.value.posizione.luogo, 'luogo');
                }
                messaggioModale.value = null;
                break;
            }
            case 'copiaIndirizzoAnagrafica': {
                // FIX: Scudo condizionale anti-undefined su stringaIndirizzo
                let strIndirizzo = '';
                const indCliente = dbClienti.value[props.idCliente]?.indirizzo;
                
                if (indCliente) {
                    const parti = [];
                    if (indCliente.via) parti.push(indCliente.via);
                    if (indCliente.civico) parti.push(indCliente.civico);
                    if (indCliente.citta) parti.push(indCliente.citta);
                    if (indCliente.provincia) parti.push(indCliente.provincia);
                    
                    strIndirizzo = parti.join(', ');
                }
                
                leadModifica(strIndirizzo, 'indirizzo');
                messaggioModale.value = null;
                break;
            }
        }
    }

    function bCambiaCliente() {
        if (!interfacciaBloccata.value && !leadDaAggiornare.value) {
            mostraElencoClientiModale.value = true;
        }
    }

    async function bCambiaClienteDaModale(tempElemento) {
        const currentIdCliente = leggiInfoDBRaw(leadSelezionato.value).idCliente || props.idCliente;
        
        if (tempElemento.idCliente != null && currentIdCliente != tempElemento.idCliente){
            formAttivo.value = false;           
            await cambiaClienteALeadInFirestore(currentIdCliente, idLeadSelezionato.value, tempElemento.idCliente);
            emit('modificaElementoInCorso', false);
            emit('elementoSelezionato', {
                tipo: 'lead',
                idCliente: tempElemento.idCliente,
                idLead: idLeadSelezionato.value
            });
        }
        mostraElencoClientiModale.value = false;
    }

    function bSelezionaTAb(index) {
        if (interfacciaBloccata.value) {
            messaggioModale.value = {
            testoLight:{testo:'Ok', comando:'annulla'},
            testoPrimary:null,
            testoDanger:null,
            messaggio:"Per proseguire devi salvare o annullare le modifiche" };
        } else {
            if ( index>1 && ( props.idLead==-1 || leadDaAggiornare.value ) ) {
                messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Per proseguire devi salvare le modifiche al lead" };
            } else {
                idPreventivoSelezionato.value = null;
                statoInterfaccia.value.formLeadTab = index;
            }
        }
    }

    function bBloccaInterfaccia(stato) {
        interfacciaBloccata.value = stato;
        emit('modificaElementoInCorso', stato);
    }

    async function gestisciSelezioneElemento(elSelezionato) {
        if (leadDaAggiornare.value != null || interfacciaBloccata.value == true) {
            messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Per proseguire devi salvare o annullare le modifiche"
            };
        } else {
            switch (elSelezionato.tipo) {
                case 'cliente':
                case 'preventivo':
                case 'contatto':
                    emit('elementoSelezionato', elSelezionato);
                    break;
                case 'preventivi':
                    idPreventivoSelezionato.value = null;
                    break;
            }
        }
    }

    function bCopiaContatti() {
        if (dbClienti.value[props.idCliente] && dbClienti.value[props.idCliente].leads && dbClienti.value[props.idCliente].leads[props.idLead]) {
            const leadCorrente = dbClienti.value[props.idCliente].leads[props.idLead];
            if ( 'contatti' in leadCorrente ) {
                copiaTrasporto.value.contatti = leadCorrente.contatti;
                if ( Object.keys(copiaTrasporto.value.contatti).length === 0 ) {
                    delete copiaTrasporto.value.contatti;
                }
            }
        }
    }

    function bIncollaContatti() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:{testo:'Incolla', comando:'incollaContatti'},
            testoDanger:null,
            messaggio:"Proseguendo verranno incollati " + Object.keys(copiaTrasporto.value.contatti).length + " contatti" };
    }

    function bCopiaPosizione() {
        copiaTrasporto.value.posizione = {indirizzo:'', luogo:''};
        
        // FIX: Protezione estrazione per copia sicura
        const leadCorrente = (dbClienti.value[props.idCliente] && dbClienti.value[props.idCliente].leads) 
                                ? dbClienti.value[props.idCliente].leads[props.idLead] 
                                : null;
        
        if ( leadCorrente && 'indirizzo' in leadCorrente ) {
            copiaTrasporto.value.posizione.indirizzo = leadCorrente.indirizzo;
        } else {
            delete copiaTrasporto.value.posizione.indirizzo;
        }
        if ( leadCorrente && 'luogo' in leadCorrente ) {
            copiaTrasporto.value.posizione.luogo = leadCorrente.luogo;
        } else {
            delete copiaTrasporto.value.posizione.luogo;
        }
        messaggioModale.value = {
            testoLight:{testo:'Ok', comando:'annulla'},
            testoPrimary:null,
            testoDanger:null,
            messaggio:"La posizione è stata copiata negli appunti"
        };
    }

    function bIncollaPosizione() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:{testo:'Incolla', comando:'incollaPosizione'},
            testoDanger:null,
            messaggio:"Proseguendo verrà sovrascritto l'indirizzo e la posizione" };
    }

    function bCopiaIndirizzoAnagrafica() {
        if (dbClienti.value[props.idCliente]?.indirizzo) {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:{testo:'Copia', comando:'copiaIndirizzoAnagrafica'},
                testoDanger:null,
                messaggio:"Proseguendo verrà sovrascritto l'indirizzo" };
            
        } else {
            messaggioModale.value = {
                testoLight:{testo:'Annulla', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Non è presente un indirizzo in anagrafica" };
        }
    }

    async function resetForm() {
        formAttivo.value = false;
        await nextTick();
        formAttivo.value = true;
    }

    async function bAggiungiTag() {
        const tag = nuovoTag.value.trim();
        if (!tag) return;

        // Inizializza l'array se proveniamo da vecchi documenti senza tags
        if (!leadSelezionato.value.tags) {
            leadSelezionato.value.tags = [];
        }

        // Aggiunge solo se non è un duplicato nel lead corrente
        if (!leadSelezionato.value.tags.includes(tag)) {
            // Creiamo un nuovo array per garantire la reattività di Vue
            const nuoviTags = [...leadSelezionato.value.tags, tag];
            leadModifica(nuoviTags, 'tags');
            
            // Verifica e aggiorna il vocabolario globale se è un tag inedito
            const tagsGlobali = impostazioniGenerali.value.tagsLeads || [];
            if (!tagsGlobali.includes(tag)) {
                await aggiungiTagLeadInFirestore(tag);
            }
        }
        // Resetta l'input
        nuovoTag.value = '';
    }

    function bRimuoviTag(index) {
        const nuoviTags = [...leadSelezionato.value.tags];
        nuoviTags.splice(index, 1);
        leadModifica(nuoviTags, 'tags');
    }

</script>